import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import { Flex } from '../UI/Flex/Flex';
interface ModalShowEvalProps {
    reason: string;
    is_valid: boolean;
}
export const ModalShowEval = observer((props: ModalShowEvalProps) => {
    const rawHtmlWithDefault = marked.parse(props.reason as string, { async: false });

    let sanitizedHtml = DOMPurify.sanitize(rawHtmlWithDefault as string);

    return (
        <Flex fillCell={true} direction="column">
            <ScrollPanel>
                <div>Eval Result: {props.is_valid ? 'Valid' : 'Invalid'}</div>
                <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>
            </ScrollPanel>
        </Flex>
    );
});
